import { Button, Chip, Stack, Typography, Box, Tooltip } from '@mui/material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';
import {
  ArrowRightAltRounded,
  CheckOutlined,
  CloseOutlined,
  EventAvailable,
  ManageHistoryOutlined,
} from '@mui/icons-material';
import { colors } from '../../utility/status';
import { format } from 'date-fns';

const CustomRow = ({ gift, handlePassClick, handleOpenFailDialog }) => {
  const id = gift[0];
  const user = gift[1];
  const currentDesignation = gift[2]?.split(' - ')[0];
  const desiredDesignation = gift[3]?.split(' - ')[0];
  const submitted = gift[4];
  const jury = gift[5];
  let juryDetails = jury?.juryDetails;
  let meetingDate = jury?.juryMeetingDate || false;
  return (
    <Stack>
      <Stack direction={'row'} alignItems={'center'} sx={{ border: 0, mb: 1 }}>
        <UserAvatar src={user?.employeePhotoPath} sx={{ mr: 1 }} />

        <Box mr={1}>
          <Typography sx={{ fontSize: variants.TINY }}>{user?.empName}</Typography>
          <Stack direction={'row'} alignItems={'center'}>
            <Typography sx={{ fontSize: variants.TINY }}>{currentDesignation}</Typography>
            <ArrowRightAltRounded />
            <Typography sx={{ fontSize: variants.TINY }}>{desiredDesignation}</Typography>
          </Stack>
          <Typography sx={{ fontSize: variants.TINY }}>{format(new Date(submitted), 'PP')}</Typography>
        </Box>
        <Box sx={{ ml: 'auto' }}>
          <Stack alignItems={'flex-start'}>
            <Button
              startIcon={<CheckOutlined fontSize='small' />}
              size='small'
              sx={{ borderColor: colors.Pass, color: colors.Pass }}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handlePassClick(id);
              }}
            >
              Pass
            </Button>
            <Button
              startIcon={<CloseOutlined fontSize='small' />}
              sx={{
                color: colors.Fail,
                fontSize: variants.TINY,
                mb: 0.5,
              }}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenFailDialog(id);
              }}
            >
              Fail
            </Button>
          </Stack>
        </Box>
      </Stack>
      {meetingDate ? (
        <Chip
          variant='outlined'
          size='small'
          icon={<EventAvailable fontSize='small' />}
          label={<Typography sx={{ fontSize: variants.TINY }}>{format(new Date(meetingDate), 'Pp')}</Typography>}
          color='success'
        />
      ) : (
        <Chip variant='outlined' size='small' label={'Not scheduled'} color='error' />
      )}
    </Stack>
  );
};
export default CustomRow;
